import Vue from 'vue';
import Vuex from 'vuex';
import auth from './auth';
import shopAuth from './shopAuth';
import permissions from './permissions';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    auth,
    shopAuth,
    permissions,
  },
});
